import { parse } from 'qs';

export const getAll = (location = {}) => (
  parse(location.search, { ignoreQueryPrefix: true, arrayLimit: 100 }));
export const get = (location, key) => getAll(location)[key];
export const set = (location, params) => ({ ...getAll(location), ...params });
export const remove = (location, key, value) => {
  const existingQueryParams = getAll(location);
  const existingQueryValue = existingQueryParams[key];
  if (value && Array.isArray(existingQueryValue)) {
    const remainingValue = existingQueryValue.filter((queryValue) => queryValue !== value);
    if (remainingValue.length) {
      return { ...existingQueryParams, [key]: remainingValue };
    }
    delete existingQueryParams[key];
  } else if (Array.isArray(key)) {
    key.forEach((currentKey) => {
      delete existingQueryParams[currentKey];
    });
  } else {
    delete existingQueryParams[key];
  }
  return existingQueryParams;
};
export const removeMany = (location, entries) => {
  const queryParams = getAll(location);

  return entries.reduce((output, [key, value]) => {
    const paramValue = output[key];

    if (paramValue && Array.isArray(paramValue)) {
      return {
        ...output,
        [key]: paramValue.filter((item) => item !== value),
      };
    }

    const { [key]: drop, ...query } = output;
    return query;
  }, queryParams);
};
